import * as React from "react";
import { PrimaryTooltip } from "Components/Shared/PrimaryTooltip";
import { DefaultButton } from "Components/Shared/Buttons/DefaultButton";
import { TooltipProps } from "@material-ui/core/Tooltip";

type Props = TooltipProps & {
  title: string;
  onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
};

export const DefaultButtonWithTooltip: React.FunctionComponent<Props> = props => {
  return (
    <PrimaryTooltip {...props} title={props.title} onClick={props.onClick}>
      <div>
        <DefaultButton>{props.children}</DefaultButton>
      </div>
    </PrimaryTooltip>
  );
};
